<template>
  <li class="agenda-item">
    <div class="agenda-item__content">
      <p v-if="blok.title" class="agenda-item__title">
        {{ blok.title }}
      </p>
      <BaseRichText :rich-text-template="blok.text" />
    </div>
  </li>
</template>

<script lang="ts" setup>
import type { SbEventAgendaListItem } from '@/types'

interface Props {
  blok: SbEventAgendaListItem
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.agenda-item {
  display: flex;

  &::before {
    @include icon('@/assets/icons/list-tick-blue.svg', 15px, 14px);

    content: '';
    flex-shrink: 0;
    position: relative;
    top: 8px;
    display: block;
    margin-right: 10px;
  }

  &__title {
    font-weight: var(--font-weight-paragraph-bold);
    margin-bottom: 0;
  }
}
</style>
